import NextImage from "next/image";
import NextLink from "next/link";

import { IcArrowRight } from "@jetblue/kit-icons/ic-arrow-right";

export type AdProperties = {
  cta: {
    href: string;
    isExternal: boolean;
    label: string;
    target?: "_blank" | "_self";
  };
  dataAttributePrefix?: string;
  imageAlt?: string;
  imageSrc?: unknown;
  subtitle: string;
  title: string;
  image?: string;
};
export const Ad = ({
  cta,
  dataAttributePrefix = "",
  imageAlt,
  image,
  subtitle,
  title,
}: AdProperties) => (
  <section
    className="flex flex-row bg-background-surface-variant-low p-6"
    data-fs-element={`${dataAttributePrefix}-ad-section`}
  >
    {imageAlt && image && (
      <div className="me-6 min-h-20 max-w-32 min-w-24 grow">
        <div className="relative inline-block size-full">
          <NextImage
            alt={imageAlt}
            fill
            objectFit="contain"
            objectPosition="left"
            src={image}
          />
        </div>
      </div>
    )}

    <div>
      <h3
        className="
          mb-2 text-title-m/7 font-semibold text-foreground-primary-variant
        "
      >
        {title}
      </h3>

      <span className="mt-2 text-label text-wrap text-foreground-on-surface">
        {subtitle}

        {cta.href && cta.label && (
          <span className="me-2 inline-block">
            <NextLink
              className="
                ms-1 flex items-center font-bold text-foreground-primary
                focus-outline

                hover:text-foreground-primary-variant hover:underline
              "
              data-fs-element={`${dataAttributePrefix}-ad-link`}
              href={cta.href}
            >
              {cta.label}

              <IcArrowRight aria-hidden className="ms-2" />
            </NextLink>
          </span>
        )}
      </span>
    </div>
  </section>
);
